export default "__VITE_ASSET__619a11af__"